export default __webpack_public_path__ + "static/media/preview-icon.3c9e0426.svg";